import { Select } from '@kcftech/design-system';
import { AssetCategoryParameterType } from '@kcftech/prometheus-client';
import { baseDefaultValueRules } from 'pages/Settings/AssetType/parameter_form/shared';
import {
    AssetParameterFormData,
    AssetParameterFormInputProps,
} from 'pages/Settings/AssetType/parameter_form/types';
import { useEffect } from 'react';
import { RegisterOptions, useFormState } from 'react-hook-form';

export const options = [
    { title: 'Unchecked', value: 'false' },
    { title: 'Checked', value: 'true' },
];

const boolDefaultValueRules: RegisterOptions<AssetParameterFormData, 'defaultValue'> = {
    ...baseDefaultValueRules,
    validate: (value) => !value || value === 'true' || value === 'false',
};

export function AssetParameterBoolFormContent({
    form,
    parameter,
}: AssetParameterFormInputProps) {
    const {
        register,
        setValue,
        watch,
        control,
    } = form;

    const {
        errors,
    } = useFormState({
        control,
    });

    const type = watch('type');

    useEffect(() => {
        if (type !== AssetCategoryParameterType.Bool) {
            throw new Error('Invalid type');
        }

        if (parameter?.CategoryParameterType === AssetCategoryParameterType.Bool) {
            setValue('defaultValue', parameter.DefaultValue ?? 'false');
        } else {
            setValue('defaultValue', 'false');
        }

        return () => {
            setValue('defaultValue', '');
        };
    }, [type, setValue, parameter?.DefaultValue, parameter?.CategoryParameterType]);

    return (
        <Select
            label="Default Status"
            error={errors.defaultValue?.message}
            options={options}
            {...register('defaultValue', boolDefaultValueRules)}
        />
    );
}
